import { IMixpanelAnalysis } from './types';

const mixpanel: IMixpanelAnalysis = __WEB__ ? require('./web').default : require('./native').default;

export default mixpanel;
